<template>
  <div>
    <div class="text-center q-py-lg">
      <import-posts-btn
        :account="account"
        color="primary"
        rounded
      />
    </div>
    <q-separator />
    <div
      v-if="supportRequested"
      class="bg-orange-2 text-center text-h6 q-my-lg q-pa-md">
      Client Requested Support
    </div>
    <import-request
      v-if="account.reconnectRequest"
      :request="account.reconnectRequest"
      :platform="account.socialSite.name"
    />
    <request-new-posts v-else :account="account" />
    <q-separator />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '@/social/types';
import ImportPostsBtn from '../../post/import/with-account/ImportPostsBtn.vue';
import ImportRequest from '../ImportRequest.vue';
import RequestNewPosts from '../RequestNewPosts.vue';

export default defineComponent({
  components: {
    RequestNewPosts,
    ImportRequest,
    ImportPostsBtn,
  },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  computed: {
    supportRequested(): boolean {
      return (
        this.account.reconnectRequest !== null
        && this.account.reconnectRequest.assignee === 'support'
      );
    },
  },
});
</script>
